import { useTranslation } from 'react-i18next';

import { SidebarCountBadge, type SidebarCountBadgeVariant } from './SidebarCountBadge';

interface SidebarQuotationExceptionQueueBadgeProps {
  count: number;
  variant?: SidebarCountBadgeVariant;
}

export function SidebarQuotationExceptionQueueBadge({
  count,
  variant,
}: SidebarQuotationExceptionQueueBadgeProps) {
  const { t } = useTranslation('admin');
  return (
    <SidebarCountBadge
      count={count}
      variant={variant}
      testId="sidebar-quotation-exception-queue-badge"
      label={t('quotation_exceptions.queue.sidebar_badge', { count })}
    />
  );
}
